<template>
  <div class="dovemed-container">
    <div class="dovemed-wrapper text-center signup-page">
      <div class="signup-container">
        <h1 class="hyper-link mb-4">Welcome</h1>
        <p class="mb-1">It looks like you don't have a claimed profile.</p>
        <p>Please search for your physician profile and claim it in order to continue.</p>

        <div class="mt-5 search-container w-100">
          <input type="search" class="search-input primary-border w-50" :style="{ border: '1px solid ' + getPrimaryColor() }" placeholder="Name" v-model="searchLastName" />
          <input type="search" class="search-input-state primary-border w-50" :style="{ border: '1px solid ' + getPrimaryColor() }" placeholder="state" v-model="searchState" />
          <button
            type="submit"
            class="search-button primary-border font-white primary-button"
            :style="{
              border: '1px solid ' + getPrimaryColor(),
              background: getPrimaryColor(),
            }"
            @click="getDoctors()"
          >
            <a-icon class="svg-icon-size" type="search" :size="'large'" />
          </button>
        </div>

        <div class="mt-3 filters-section text-left" v-if="showFilters">
          <span class="bold-text cp" @click="() => (hideFiltersToggle = !hideFiltersToggle)"
            ><u>{{ !hideFiltersToggle ? "Show" : "Hide" }} Filters</u></span
          >
          <span class="ml-5 hyper-link cp" v-if="hideFiltersToggle">Clear Filters</span>

          <div class="filters-cont" v-bind:class="!hideFiltersToggle ? 'transparent' : ''">
            <div class="row mt-4">
              <div class="col-6">
                <label for="FirstName" class="mb-1">First Name</label>
                <a-input :size="'large'" placeholder="Enter First Name" v-model="searchFirstName" @keyup="getDoctors()" />
              </div>
              <div class="col-6">
                <label for="city" class="mb-1">City</label>
                <a-input :size="'large'" placeholder="City" v-model="searchCity" @keyup="getDoctors()" />
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-6">
                <label for="speciality" class="mb-1">Specialty</label>
                <a-input :size="'large'" placeholder="Specialty" v-model="searchSpeciality" @keyup="getDoctors()" />
              </div>
              <div class="col-6">
                <p class="m-0">
                  <label for="gender" class="mb-1">Gender</label>
                </p>
                <label class="text-center radio-btn" for="maleRadio">
                  <input id="maleRadio" class="primary-input-height" type="radio" name="gender" value="m" v-model="searchGender" @change="getDoctors()" />
                  <div class="input-placeholder male cp">
                    <span class="align-text-top">Male</span>
                  </div>
                </label>
                <label class="text-center radio-btn" for="femaleRadio">
                  <input id="femaleRadio" class="primary-input-height" type="radio" name="gender" value="f" v-model="searchGender" @change="getDoctors()" />
                  <div class="input-placeholder female cp">
                    <span class="align-text-top">Female</span>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="row m-0" v-if="doctorsList.results && doctorsList.results.length === 0">
          <div class="no-results-container col-12 mt-3">
            <p class="mb-0">It seems your physician profile is not in our database.</p>
            <p>Please create your profile to get reviews and respond to your patients.</p>
            <!-- <router-link to="doctorProfile">
              <div class="create-button mt-3">
                <button class='dovemed-button primary-button font-white'
                :style="{background: getPrimaryColor()}"
                >CREATE PROFILE</button>
              </div>
            </router-link> -->
          </div>
        </div>

        <div class="doctors-search-result" v-if="doctorsList.results && doctorsList.results.length > 0">
          <hr />
          <div id="cards-section-top"></div>
          <br />

          <p class="text-right m-0">
            <small>{{ doctorsList.total_hits }} results</small>
          </p>

          <div class="row">
            <div class="col-6 mb-5" v-for="doctor in filteredDoctorsList" :key="doctor.id">
              <div class="claim-card">
                <div class="user-name d-flex p-3">
                  <div
                    class="bg-img d-block background-image"
                    v-bind:style="{
                      background: `url('https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/${doctor.gender === 'm' ? 'MALE DOCTOR2x.png' : 'WOMAN DOCTOR2x.png'}')`,
                    }"
                  >
                    <span class="rating-badge font-white primary-dark-background px-2">* {{ doctor.overall_rating ? doctor.overall_rating : doctor.rating }}</span>
                  </div>
                  <div class="d-inline-block text-left ml-2 align-self-center overflow-hidden">
                    <p class="m-0 bold-text text-truncate">
                      {{ doctor.first_name }} {{ doctor.last_name }},
                      {{ doctor.title }}
                    </p>
                    <small>{{ csvArray(doctor.areas_of_practice) }} </small>
                  </div>
                </div>
                <div class="user-address d-flex p-3">
                  <div class="pin-img"></div>
                  <div class="d-inline-block text-left ml-2 align-self-center overflow-hidden">
                    <p class="m-0">
                      <small>{{ doctor.address }}, {{ doctor.city }}, {{ doctor.state }}</small>
                    </p>
                    <p class="m-0">
                      <small>{{ roundNumber(doctor.distance) }} miles</small>
                    </p>
                  </div>
                </div>
                <div class="secondary-dark-background dovemed-card-footer p-2 d-flex justify-content-between">
                  <div>
                    <span class="">(100K)</span>
                    <span class="ml-2">(20)</span>
                    <span class="ml-2">(43)</span>
                  </div>
                  <div>
                    <span class="claim-link hyper-link text-right cp" @click="$refs.ClaimProfileModal.show(doctor)">CLAIM PROFILE</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <a-pagination :total="doctorsList.total_hits" :current="doctorsList.page + 1" @change="getDoctorsPage()" />
        </div>
        <ClaimProfileModal ref="ClaimProfileModal" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
import ClaimProfileModal from "../Modals/ClaimProfile"

export default {
  name: "ClaimProfile",
  components: {
    ClaimProfileModal,
  },
  data() {
    return {
      hideFiltersToggle: false,
      searchFirstName: "",
      searchLastName: "",
      searchCity: "",
      searchState: "",
      searchSpeciality: "",
      searchGender: "",
      selectedDoctorProfile: {},
    }
  },
  computed: {
    ...mapState({
      filteredDoctorsList: state => state.Signup.claimProfile.filteredDoctorsList,
      doctorsList: state => state.Signup.claimProfile.doctorsList,
      showFilters: state => state.Signup.claimProfile.showFilters,
    }),
  },
  methods: {
    getDoctors() {
      // console.log("getDoctors() is called")

      const payload = {}
      if (this.searchFirstName) payload.searchFirstName = this.searchFirstName
      if (this.searchLastName) payload.searchLastName = this.searchLastName
      if (this.searchCity) payload.searchCity = this.searchCity
      if (this.searchSpeciality) payload.searchSpeciality = this.searchSpeciality
      if (this.searchGender) payload.searchGender = this.searchGender

      this.$store.dispatch("Signup/getDoctors", payload)
    },
    getDoctorsPage() {
      const payload = {}
      if (this.searchFirstName) payload.searchFirstName = this.searchFirstName
      if (this.searchLastName) payload.searchLastName = this.searchLastName
      if (this.searchCity) payload.searchCity = this.searchCity
      if (this.searchSpeciality) payload.searchSpeciality = this.searchSpeciality
      if (this.searchGender) payload.searchGender = this.searchGender
      if (this.doctorsList && this.doctorsList.next_page) payload.next_page = this.doctorsList.next_page

      this.$store.dispatch("Signup/getDoctorsPage", payload)
      document.getElementById("cards-section-top").scrollIntoView()
    },
    roundNumber(number) {
      return Math.round(number)
    },
    filterName(val) {
      if (val) {
        this.filteredDoctorsList = this.doctorsList.results.filter(v => {
          let x = v.first_name.toLowerCase()
          if (x.includes(val.toLowerCase())) {
            return v
          }
        })
      } else {
        this.filteredDoctorsList = [...this.doctorsList.results]
      }
    },
    csvArray(arr) {
      if (arr) {
        return arr.join(", ")
      }
    },
  },
  mounted() {
    console.warn('ClaimProfile.vue is mounted');
  },
}
</script>

<style lang="scss" scoped>
.signup-page {
  padding: 70px;
}

.search-container {
  display: flex;

  .search-input {
    padding: 10px;
    border-radius: 8px 0 0 8px;
    // min-width: 350px;

    &:focus {
      outline: none;
    }
  }

  .search-input-state {
    border-left: 0 !important;
    padding: 10px;
    // width: 350px;

    &:focus {
      outline: none;
    }
  }

  .search-button {
    max-width: 100px;
    border-radius: 0 8px 8px 0;

    &:focus {
      outline: none;
    }
  }
}

.input-placeholder {
  min-width: unset;

  &.male {
    border-radius: 8px 0 0 8px;
  }

  &.female {
    border-radius: 0 8px 8px 0;
    margin-left: -5px;
  }
}

.claim-card {
  border: 1px solid #ccc;
  width: 100%;
  border-radius: 8px;

  .user-name {
    .bg-img {
      position: relative;
      border: 1px solid #ccc;
      min-width: 100px;
      max-width: 100px;
      min-height: 100px;
      max-height: 100px;
      border-radius: 50%;
      display: inline-block;

      .rating-badge {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 20%);
        font-size: 15px;
        border-radius: 20px;
        width: 55%;
      }
    }
  }

  .user-address {
    line-height: 15px;
  }

  .dovemed-card-footer {
    border-top: 1px solid rgba(0, 0, 0, 0.125);

    span {
      font-size: 12px;
    }
  }
}

.claim-modal-header {
  border-radius: 5px 5px 0 0;
  min-height: 100px;
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;

  .profile-img {
    min-width: 150px;
    max-width: 150px;
    min-height: 150px;
    max-height: 150px;
    display: block;
    border-radius: 50%;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 50%);
    box-shadow: 0px 5px 7px 0px rgba(0, 0, 0, 0.4);
  }
}

.profile-details {
  padding-top: 170px;
  max-width: 60%;
  margin: auto;
}

.terms-modal-container {
  padding: 30px;
  text-align: center;
}

.background-image {
  background-position: center !important;
  background-size: contain !important;
  background-repeat: no-repeat !important;
}

.filters-cont {
  transition: height 0.3s ease-in-out;
}

.transparent {
  opacity: 0;
  display: none;
}

.no-results-container {
  background: rgb(246, 246, 246);
  padding: 20px;
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Signup/ClaimProfile.vue